import {RHFAutocomplete} from './rhf-autocomplete';
import {RHFCheckbox, RHFMultiCheckbox} from './rhf-checkbox';
import {RHFDatePicker} from './rhf-date-picker';
import {RHFEditor} from './rhf-editor';
import {RHFInputField} from './rhf-input-field';
import {RHFRadioGroup} from './rhf-radio-group';
import {RHFMultiSelect, RHFSelect} from './rhf-select';
import {RHFSwitch} from './rhf-switch';
import {RHFTextField} from './rhf-text-field';
import {RHFUpload, RHFUploadBox} from './rhf-upload';

// ----------------------------------------------------------------------

export const Field = {
  Autocomplete: RHFAutocomplete,
  Checkbox: RHFCheckbox,
  Editor: RHFEditor,
  Input: RHFInputField,
  MultiCheckbox: RHFMultiCheckbox,
  MultiSelect: RHFMultiSelect,
  RadioGroup: RHFRadioGroup,
  Select: RHFSelect,
  Switch: RHFSwitch,
  Text: RHFTextField,
  Upload: RHFUpload,
  UploadBox: RHFUploadBox,
  DatePicker: RHFDatePicker,
};
